import DzialkiLayer, { PARCEL_BASE_STYLE } from './DzialkiLayer';
import { setVisibility } from '../utils/maplibre-helpers';

export default class DzialkiVectorTileLayer extends DzialkiLayer {
    static ID = 'dzialki';
    static DESCRIPTION = 'Działki ewidencyjne z Ewidencji Gruntów i Budynków';
    static BASE_LAYER_IDS = ['lyr-dzialki-line'];
    static RENDER_ORDER_LAYER_IDS = DzialkiVectorTileLayer.BASE_LAYER_IDS.concat(DzialkiLayer.SELECTED_LAYER_IDS);

    buildTileUrl() {
        return (this.config.baseUrl || '') + 'api/dzialki-mvt/{z}/{x}/{y}.pbf';
    }

    getLayerIds() {
        return DzialkiVectorTileLayer.BASE_LAYER_IDS;
    }

    getRenderOrderLayerIds() {
        return DzialkiVectorTileLayer.RENDER_ORDER_LAYER_IDS;
    }

    load() {
        if (!this.isActive() || !this.canActivate()) {
            if (this.config.onRequestStarted) {
                this.config.onRequestStarted(this);
            }
            this.clear();
            if (this.config.onRequestSettled) {
                this.config.onRequestSettled(this);
            }
            return;
        }

        const map = this.getMap();
        if (!map) return;

        if (this.config.onRequestStarted) {
            this.config.onRequestStarted(this);
        }

        const sourceId = this.getSourceId();
        if (!map.getSource(sourceId)) {
            map.addSource(sourceId, {
                type: 'vector',
                tiles: [this.buildTileUrl()],
                maxzoom: this.config.maxZoom || 22
            });
            map.addLayer({
                id: DzialkiVectorTileLayer.BASE_LAYER_IDS[0],
                type: 'line',
                source: sourceId,
                'source-layer': 'dzialki',
                minzoom: this.minZoom,
                paint: {
                    'line-color': PARCEL_BASE_STYLE.color,
                    'line-width': PARCEL_BASE_STYLE.weight
                }
            });
        }
        setVisibility(map, DzialkiVectorTileLayer.BASE_LAYER_IDS[0], true);

        if (this.config.setLayer) {
            this.config.setLayer(sourceId);
        }

        if (this.config.onLoaded) {
            this.config.onLoaded();
        }
        if (this.config.onRequestSettled) {
            this.config.onRequestSettled(this);
        }
    }

    clear() {
        this.removeLayerFromMap();
        if (this.config.onCleared) {
            this.config.onCleared();
        }
    }
}
